export default "__VITE_ASSET__DuKCrDkr__"